import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const InviteUserModal = ({ onClose }) => {
  const { awsCredentials } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleInvite = async (e) => {
    e.preventDefault();

    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Create user in Cognito using AWS SDK
      const { CognitoIdentityProviderClient, AdminCreateUserCommand } = await import('@aws-sdk/client-cognito-identity-provider');

      const config = {
        region: process.env.REACT_APP_AWS_REGION,
        credentials: awsCredentials
      };

      const client = new CognitoIdentityProviderClient(config);

      const command = new AdminCreateUserCommand({
        UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        Username: email,
        UserAttributes: [
          {
            Name: 'email',
            Value: email
          },
          {
            Name: 'email_verified',
            Value: 'true'
          }
        ],
        DesiredDeliveryMediums: ['EMAIL']
      });

      await client.send(command);

      setSuccess(true);
      setEmail('');

      // Close modal after 2 seconds
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (err) {
      console.error('Error inviting user:', err);
      if (err.name === 'UsernameExistsException') {
        setError('User with this email already exists');
      } else {
        setError(err.message || 'Failed to invite user. Make sure you have admin permissions.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aws-modal-overlay" onClick={onClose}>
      <div className="aws-modal" onClick={(e) => e.stopPropagation()}>
        <div className="aws-modal-header">
          <h2>Invite User</h2>
          <button className="aws-modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleInvite}>
          <div className="aws-modal-body">
            {error && (
              <div className="aws-alert aws-alert-error" style={{ marginBottom: '16px' }}>
                {error}
              </div>
            )}

            {success && (
              <div className="aws-alert aws-alert-success" style={{ marginBottom: '16px' }}>
                Invitation sent successfully! The user will receive an email with login credentials.
              </div>
            )}

            <div className="aws-form-group">
              <label className="aws-label">Email Address</label>
              <input
                type="email"
                className="aws-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="user@example.com"
                required
                disabled={loading || success}
              />
              <p className="aws-form-help">
                The user will receive an email with a temporary password and login instructions.
              </p>
            </div>
          </div>

          <div className="aws-modal-footer">
            <button
              type="button"
              className="aws-button aws-button-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="aws-button aws-button-primary"
              disabled={loading || success || !email}
            >
              {loading ? 'Sending invitation...' : 'Send Invitation'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InviteUserModal;
